import { makeRequest } from "../utils/api";

export const getEmployments = () => {
  return makeRequest(`/employments/`, "GET");
};

export const deleteEmployment = ({ id }) => {
  return makeRequest(`/employments/${id}`, "DELETE");
};

export const createEmployment =
  (setError) =>
  ({
    identifier,
    categories,
    hourly_rate,
    hourly_rate_currency,
    is_private,
  }) => {
    return makeRequest(
      `/employments/`,
      "POST",
      { identifier, categories, hourly_rate, hourly_rate_currency, is_private },
      false,
      setError
    );
  };

export const updateEmployment =
  (setError) =>
  ({
    id,
    identifier,
    categories,
    hourly_rate,
    hourly_rate_currency,
    is_private,
  }) => {
    return makeRequest(
      `/employments/${id}/`,
      "PUT",
      { identifier, categories, hourly_rate, hourly_rate_currency, is_private },
      false,
      setError
    );
  };

export const updateEmploymentByEmployee =
  (setError) =>
  ({ employmentId, status, hourly_rate, hourly_rate_currency }) => {
    return makeRequest(
      `/employments/${employmentId}/status`,
      "POST",
      { status, hourly_rate, hourly_rate_currency },
      false,
      setError
    );
  };

export const getStatistics = () => {
  return makeRequest(`/employments/statistics`, "GET");
};
